import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

function NoImage({ logoImage }) {

    return (
        <div className='d-flex h-100 w-100 outline border border-3 border-dashed my-2 p-5 opacity-25 justify-content-center align-items-center'>
            <img src={logoImage} className='img-fluid' style={{maxWidth: '200px'}} />
            {/* <svg width="100%" height="200px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <defs>
                    <rect id="path-1" x="20" y="15" width="100%" height="100%"></rect>
                    <mask id="mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="100%" height="100%" fill="white">
                        <use xlinkHref="#path-1"></use>
                    </mask>
                </defs>
                <g id="Default-Event_Icon-Copy-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <use id="Rectangle" stroke="#979797" mask="url(#mask-2)" strokeWidth="8" opacity="0.308477493" strokeDasharray="17,6" xlinkHref="#path-1"></use>
                    <image id="Bitmap" opacity="0.29313151" x="81.6047904" y="133" width="100px" xlinkHref={logoImage}></image>
                </g>
            </svg> */}
        </div>
    )
}

NoImage.propTypes = {
    logoImage: PropTypes.string
}

NoImage.defaulProps = {
    logoImage: ''
}


function mapStateToProps({ globalReducers }) {
	return {
		logoImage: globalReducers?.logoImage
	}
}
export default connect(mapStateToProps)(NoImage)